import React, {useEffect, useState} from 'react';
import { Table } from 'antd';
import server from "../../server";
import {SearchCriteriaConfig, SearchParams} from "./search-criteria/type/search-criteria.type";
import SearchCriteria from "./search-criteria/search-criteria";

const SearchUsage: React.FC = () => {
    const [loading, setLoading] = useState(false);
    const [employees, setEmployees] = useState([]);

    // useEffect(() => {
    //     onInit();
    // }, [])
    //
    // async function onInit() {
    //     const data = await server.employee.search({});
    //     setEmployees(data);
    // }

    // Define search criteria for employee table
    const employeeSearchCriteria: SearchCriteriaConfig[] = [
        {
            key: 'name',
            label: 'Name',
            inputType: 'text',
            placeholder: 'Enter employee name'
        },
        {
            key: 'email',
            label: 'Email',
            inputType: 'email',
            placeholder: 'Enter email address'
        },
        {
            key: 'employeeCode',
            label: 'Employee Code',
            inputType: 'text',
            placeholder: 'Enter employee code'
        },
        {
            key: 'designation',
            label: 'Designation',
            inputType: 'select',
            options: [
                { value: 'SOFTWARE_DEVELOPER', label: 'Software Developer' },
                { value: 'SENIOR_DEVELOPER', label: 'Senior Developer' },
                { value: 'TECH_LEAD', label: 'Tech Lead' },
                { value: 'MANAGER', label: 'Manager' },
            ]
        },
        {
            key: 'joiningDate',
            label: 'Joining Date',
            inputType: 'date-range'
        },
        {
            key: 'active',
            label: 'Active Status',
            inputType: 'toggle'
        },
    ];

    const handleSearch = async (params: SearchParams) => {
        setLoading(true);
        console.log('Search params:', params);

        try {
            // API call to fetch employees based on search params
            // const response = await api.searchEmployees(params);
            // setEmployees(response.data);
        } catch (error) {
            console.error('Search failed:', error);
        } finally {
            setLoading(false);
        }
    };

    const columns = [
        { title: 'Name', dataIndex: 'name', key: 'name' },
        { title: 'Email', dataIndex: 'email', key: 'email' },
        { title: 'Code', dataIndex: 'employeeCode', key: 'employeeCode' },
        { title: 'Designation', dataIndex: 'designation', key: 'designation' },
    ];

    return (
        <div>
            <SearchCriteria
                searchCriteria={employeeSearchCriteria}
                onSearch={handleSearch}
                showReset={true}
                title={"Employee Search"}
                subtitle={"Find employees using multiple search criteria"}
            />

            <Table
                columns={columns}
                dataSource={employees}
                loading={loading}
                style={{ marginTop: 24 }}
            />
        </div>
    );
};

export default SearchUsage;